import type { SkillGroup } from '@/types';

export const SKILL_GROUPS: SkillGroup[] = [
  {
    label: 'Quality & Inspection',
    skills: [
      { name: 'ISO 9001 quality · ITP · NCR',                   percentage: 93, colorVar: 'var(--color-anticiper)' },
      { name: 'Inspection · GD&T · Hexagon · CMM · FARO',       percentage: 90, colorVar: 'var(--color-anticiper)' },
      { name: 'NDT coordination · UT · MT · PT',                percentage: 88, colorVar: 'var(--color-maitrise)' },
      { name: 'ASME · ASTM · ISO standards',                    percentage: 87, colorVar: 'var(--color-maitrise)' },
      { name: 'Paint inspection · welding · heat treatment',    percentage: 84, colorVar: 'var(--color-piloter)' },
    ],
  },
  {
    label: 'Artificial Intelligence',
    skills: [
      { name: 'AI agents · RAG · Domain context',               percentage: 94, colorVar: 'var(--color-temps)' },
      { name: 'Claude API · Gemini API · Local LLMs',           percentage: 91, colorVar: 'var(--color-temps)' },
      { name: 'Prompt engineering · Structured instructions',   percentage: 89, colorVar: 'var(--color-maitrise)' },
      { name: 'Quality automation · AI workflows',              percentage: 88, colorVar: 'var(--color-maitrise)' },
      { name: 'React + Firebase development (AI-assisted)',     percentage: 85, colorVar: 'var(--color-ciel)' },
    ],
  },
  {
    label: 'Project Management & Coordination',
    skills: [
      { name: 'Multi-trade coordination: machining · welding · blasting · paint', percentage: 90, colorVar: 'var(--color-ameliorer)' },
      { name: 'Rehabilitation of hydroelectric and steel-mill parts', percentage: 88, colorVar: 'var(--color-ameliorer)' },
      { name: 'CMMS · ERP-integrated maintenance · Planning',   percentage: 88, colorVar: 'var(--color-piloter)' },
      { name: 'Continuous improvement · 5S · FMEA · Pareto',    percentage: 86, colorVar: 'var(--color-piloter)' },
      { name: 'Client hold points in English: Hydro-Québec · GE · Andritz', percentage: 85, colorVar: 'var(--color-ciel)' },
    ],
  },
  {
    label: 'Tools & Development',
    skills: [
      { name: 'KPI · PowerBI · Advanced Excel',                 percentage: 88, colorVar: 'var(--color-ameliorer)' },
      { name: 'ERP: Notixia · Genius',                          percentage: 87, colorVar: 'var(--color-temps)' },
      { name: 'Python · PowerApps · Automation',                percentage: 83, colorVar: 'var(--color-ciel)' },
      { name: 'CAD: SolidWorks · SolidEdge · CATIA V5/V6',      percentage: 82, colorVar: 'var(--color-piloter)' },
      { name: 'MS Project · Gantt · Kanban',                    percentage: 82, colorVar: 'var(--color-anticiper)' },
    ],
  },
];
